module.exports = "<div id=\"ctr\">\n\t<div id=\"card-element\"></div>\n</div>"